import { render, staticRenderFns } from "./DeptRoleDataruleModal.vue?vue&type=template&id=239f048b&scoped=true"
import script from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f048b",
  null
  
)

export default component.exports